<template>
  <div id="cesium-container" ref="cesiumContainer">
    <div id="blurred-background" v-if="loading">
      <v-progress-circular
        id="loading-indicator"
        :size="40"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <cesium-recorder ref="cesiumRecorder" />
  </div>
</template>

<script>
import __ from 'lodash'
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import { EarthMesh } from '../../components/ThreeD/EarthMesh'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'

export default {
  name: 'earthMesh-cesium-viewer',
  mixins: [CesiumInitialization, EarthMesh],
  props: ['mesh', 'points'],
  components: {
    'cesium-recorder': CesiumRecorder
  },
  data() {
    return {
      loading: false,
      maxMeshPointsNumber: 125000
    }
  },
  watch: {
    points() {
      this.onMeshDataUpdated()
    },
    mesh() {
      this.onMeshDataUpdated()
    }
  },

  mounted() {
    this.initializeViewer()
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.deactivateControls()
    this.initMeshesPC()
    this.enableRectangles()
  },

  methods: {
    onMeshDataUpdated() {
      if (this.points === null || !this.mesh) {
        return
      }
      this.loading = true
      const meshCopy = this.onMeshUpdate(this.mesh)
      if (this.points?.length <= this.maxMeshPointsNumber) {
        this.createRectanglePrimitives([meshCopy], [this.points])
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 2;
}
#blurred-background {
  background-color: black;
  opacity: 0.5;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 3;
}

#loading-indicator {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 4;
  display: block;
}
</style>
